import type { EventCallback, HttpMethod } from '../components/event-callbacks'

/**
 * Converts frontend events array to backend dict format.
 * Array: [{ id, event_type, url, method }]
 * Dict:  { event_type: { url, method } }
 * Duplicate event_types use last-write-wins.
 */
export const eventsArrayToDict = (
  events: EventCallback[] | undefined | null,
): Record<string, { url: string; method: string }> => {
  if (!events || !Array.isArray(events)) return {}
  const dict: Record<string, { url: string; method: string }> = {}
  for (const event of events) {
    if (!event.event_type || !event.url) continue
    dict[event.event_type] = { url: event.url, method: event.method }
  }
  return dict
}

/**
 * Converts backend dict format to frontend events array.
 * Only includes entries where url is non-empty.
 * Uses event_type as stable id to avoid false positives in change detection.
 */
export const eventsDictToArray = (
  events: Record<string, { url: string; method: string }> | undefined | null,
): EventCallback[] => {
  if (!events || typeof events !== 'object') return []
  return Object.entries(events)
    .filter(([, value]) => value?.url)
    .map(([key, value]) => ({
      id: key,
      event_type: key,
      url: value.url,
      method: (value.method || 'POST') as HttpMethod,
    }))
}
